import { ITableIndex } from "./ITableIndex";

export interface ILinkedObjectSpecifiable {
  type: string;
  id?: number;
  key: string;
  subKey?: string;
  tableIndex?: ITableIndex;
  isDate?: boolean;
}

export function instanceOfILinkedObjectSpecifiable(instance: any): instance is ILinkedObjectSpecifiable {
  return instance
    && instance.type
    && instance.key;
}
